export default `
  fragment UserFragment on User {
    id
    account {
      id
    }
    firstName
    lastName
    fullName
    email
    phone
    status
    settings
  }
`;
